import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

export type MeasureSize = 'xl' | '2xl' | '3xl' | '4xl' | '5xl'

export type MeasureProps = React.ComponentProps<'div'> & {
  asChild?: boolean
  size?: MeasureSize
  padded?: boolean
  centered?: boolean
}

const sizeClassMap: Record<MeasureSize, string> = {
  'xl': 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
}

export const Measure = React.forwardRef<HTMLDivElement, MeasureProps>(
  (
    {
      asChild = false,
      size = '3xl',
      padded = false,
      centered = true,
      className,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'div'

    return (
      <Comp
        ref={ref}
        className={cn(
          sizeClassMap[size],
          centered && 'mx-auto',
          padded && 'px-6 lg:px-8',
          className,
        )}
        {...props}
      />
    )
  },
)

Measure.displayName = 'Measure'

